import React from 'react';

type FlowCommentCountProps = {
  commentCount?: number;
};

const FlowCommentCount: React.FC<FlowCommentCountProps> = ({
  commentCount
}) => {
  return (
    <>
      Comments
      {commentCount > 0 && <span> ({commentCount})</span>}
    </>
  );
};

export default FlowCommentCount;
